import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-link"
export default class extends Controller {
  static targets = ["button"]

  copy(event) {
    event.preventDefault()
    const link = window.location.href
    navigator.clipboard.writeText(link).then(() => {
      this.buttonTarget.textContent = this.buttonTarget.dataset.success;
      this.buttonTarget.classList.add("button--success")
    })
  }
}
